export enum HireFormTodoKey {
  Requested12HoursAgo = 'Requested12HoursAgo',
  Requested24HoursAgo = 'Requested24HoursAgo',
  Requested48HoursAgo = 'Requested48HoursAgo',
  Requested72HoursAgo = 'Requested72HoursAgo',
  Resubmission12HoursAgo = 'Resubmission12HoursAgo',
  Resubmission24HoursAgo = 'Resubmission24HoursAgo',
  Resubmission48HoursAgo = 'Resubmission48HoursAgo',
  Resubmission72HoursAgo = 'Resubmission72HoursAgo',
}

export enum OfferStageTodoKey {
  TwelveHoursAgo = '12HoursAgo',
  TwentyFourHoursAgo = '24HoursAgo',
  ThirtySixHoursAgo = '36HoursAgo',
  FortyEightHoursAgo = '48HoursAgo',
}

export type TodoItem<K extends string> = {
  key: K;
  enabled: boolean;
};

export type TodosConfig = {
  hireForm?: Array<TodoItem<HireFormTodoKey>>;
  offerMade?: Array<TodoItem<OfferStageTodoKey>>;
  offerRejected?: Array<TodoItem<OfferStageTodoKey>>;
  offerExpired?: Array<TodoItem<OfferStageTodoKey>>;
};
export interface TodoRowConfig<K extends HireFormTodoKey | OfferStageTodoKey> {
  enumKey: K;
  i18nKey: string;
}
